
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/actions';
import * as apis from '@/apis/simactivation';
import { ESIM_ACTIVATION_CODE_REQUEST, ESIM_RETRIGGER_MULTI_RECP_REQUEST ,  SIM_ACTIVATION_STATUS_REQUEST, SIM_ACTIVATION_SUBMIT_REQUEST } from "@/actions/simactivation/actionTypes";

function* triggerESimActivationCode(payload) {
    try {
        const result = yield call(apis.triggerESIMActivationEmail, payload.esimActReq);
        yield put(actions.getESIMActivationCode.success(result.data));
    } catch (error) {
        yield put(actions.getESIMActivationCode.failure(error));
    }
}

function* triggerESimUploadMultiRecp({ payload }: any) {
    try {
        const formData = new FormData();
        [...payload].forEach(file => {
            formData.append("files", file);
        });
        const result = yield call(apis.triggerESIMActivationMultiRecp, formData);
        yield put(actions.eSIMTriggerMultiRecp.success(result.data));
    } catch (error) {
        yield put(actions.eSIMTriggerMultiRecp.failure(error));
    }
}

function* triggerSimActivationStatus({ reqData }: any) {
    try {
      const result = yield call(apis.triggerSimActivationStatus, reqData);
      yield put(actions.simActivationStatus.success(result.data));
    } catch (error) {
      yield put(actions.simActivationStatus.failure(error));
    }
  }
  
  function* triggerSimActivationSubmit({ reqData }: any) {
    try {
      const result = yield call(apis.triggerSimActivationSubmit, reqData);
      yield put(actions.simActivationSubmit.success(result.data));
    } catch (error) {
      yield put(actions.simActivationSubmit.failure(error));
    }
  }

export default function* simactivationsagas() {
    yield takeLatest(ESIM_ACTIVATION_CODE_REQUEST, triggerESimActivationCode);
    yield takeLatest(ESIM_RETRIGGER_MULTI_RECP_REQUEST, triggerESimUploadMultiRecp);
    yield takeLatest(SIM_ACTIVATION_STATUS_REQUEST,triggerSimActivationStatus);
    yield takeLatest(SIM_ACTIVATION_SUBMIT_REQUEST,triggerSimActivationSubmit);
}